import * as Status from 'constants/statuses';

export default {
  fetchedProducts: [],
  giftsSets: null,
  productsStatus: Status.IDLE,
  giftsSetsStatus: Status.IDLE,
};
